import {
  CREATE_TASKS_NEW_RECORD,
  CREATE_TASKS_NEW_RECORD_SUCCESS,
  CREATE_TASKS_NEW_RECORD_ERROR,

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,

} from "../actions";

export const createTaskNewRecord = (newRecord, history) => ({
    type: CREATE_TASKS_NEW_RECORD,
    payload: {newRecord, history}
  });

export const createTaskNewRecordSuccess = (recordCreated) => ({
  type: CREATE_TASKS_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createTaskNewRecordError = (message) => ({
  type: CREATE_TASKS_NEW_RECORD_ERROR,
  payload: { message },
});

export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});